<div class="margin-top-lg">
	<mat-card-title class="h5">
		Eligibility Status
		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="18"></mat-spinner>
		</mat-icon>
	</mat-card-title>
	<mat-divider> </mat-divider>

	<mat-card-content class="margin-top-lg"
		*ngIf="!isLoading && (!studentEligibilities || studentEligibilities.length === 0)">
		<h3>This child does not have any eligibility statuses.</h3>
	</mat-card-content>

	<div *ngIf="!isLoading && studentEligibilities && studentEligibilities.length > 0"
		class="margin-top-md table-responsive">
		<mat-table [dataSource]="studentEligibilityTableDataSource" class="mat-elevation-z1" matSort>

			<ng-container matColumnDef="CO.REGION.CODE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Region </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.CO.REGION.CODE}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="CO.COE_NUMBER">
				<mat-header-cell *matHeaderCellDef mat-sort-header> COE Number </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						<a [routerLink]="['/coe/dynamic/', element.CO.ID]" target="_blank" class="link-minified"
							[ngClass]="{'danger bold': element.STUDENT_ELIGIBILITY_STATUS[0].ELIGIBILITY_STATUS.STATUS == 'INELIGIBLE', 'eligibleCls': element.STUDENT_ELIGIBILITY_STATUS[0].ELIGIBILITY_STATUS.STATUS == 'ELIGIBLE'}">
							{{element.CO.COE_NUMBER}}
						</a>
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="CO.SIGN_DATE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Signature Date </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div
						[ngClass]="{'line-through': element.STUDENT_ELIGIBILITY_STATUS[0].ELIGIBILITY_STATUS.STATUS == 'INELIGIBLE'}">
						{{element.CO.SIGN_DATE | cleanDate | simpleDate}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="CO.QUALIFYING_ARRIVAL_DATE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> QAD </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div
						[ngClass]="{'line-through': element.STUDENT_ELIGIBILITY_STATUS[0].ELIGIBILITY_STATUS.STATUS == 'INELIGIBLE'}">
						{{element.CO.QUALIFYING_ARRIVAL_DATE | cleanDate | simpleDate}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="CO.COE_MOVES[0].RESIDENCY_DATE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Residency Date </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div
						[ngClass]="{'line-through': element.STUDENT_ELIGIBILITY_STATUS[0].ELIGIBILITY_STATUS.STATUS == 'INELIGIBLE'}">
						{{element.CO.COE_MOVES[0].RESIDENCY_DATE | cleanDate | simpleDate}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="ELIGIBILITY_END_DATE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> COE EOE </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div
						[ngClass]="{'line-through': element.STUDENT_ELIGIBILITY_STATUS[0].ELIGIBILITY_STATUS.STATUS == 'INELIGIBLE'}">
						{{element.ELIGIBILITY_END_DATE | cleanDate | simpleDate}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="STUDENT_ELIGIBILITY_STATUS[0].ELIGIBILITY_STATUS.STATUS">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div
						[ngClass]="{'danger bold': element.STUDENT_ELIGIBILITY_STATUS[0].ELIGIBILITY_STATUS.STATUS == 'INELIGIBLE'}">
						{{element.STUDENT_ELIGIBILITY_STATUS[0].ELIGIBILITY_STATUS.STATUS | titlecase}}
					</div>
				</mat-cell>
			</ng-container>

			<mat-header-row *matHeaderRowDef="studentEligibilityDisplayedColumns"></mat-header-row>
			<mat-row *matRowDef="let row; columns: studentEligibilityDisplayedColumns;"></mat-row>
		</mat-table>

	</div>
</div>